import { cloudinarySrcSet, cloudinaryTypedSrcSet, optimizeImage } from "../utils/optimizeImage";

// LCP image for article heroes and category leads: AVIF → WebP → f_auto fallback. The srcset/sizes here must stay
// identical to the preload emitted by public/index.html (same widths, same sizes) so the preloaded bytes are reused.
export const LeadPicture = ({ src, widths, sizes, width, height, alt, className, imgProps = {} }) => {
  const avif = cloudinaryTypedSrcSet(src, "avif", widths);
  const webp = cloudinaryTypedSrcSet(src, "webp", widths);
  const img = (
    <img
      src={optimizeImage(src, { width: widths[widths.length - 1] })}
      srcSet={cloudinarySrcSet(src, widths)}
      sizes={sizes}
      width={width}
      height={height}
      alt={alt}
      fetchPriority="high"
      decoding="async"
      className={className}
      {...imgProps}
    />
  );
  if (!avif) return img;
  return (
    <picture>
      <source type="image/avif" srcSet={avif} sizes={sizes} />
      <source type="image/webp" srcSet={webp} sizes={sizes} />
      {img}
    </picture>
  );
};

export default LeadPicture;
